import React, { PureComponent, ReactNode } from 'react'
import { images } from '../../images'
import { ILandingContact, IPartnerLogo } from '../../models'
import { LiteralsService } from '../../services'
import StyledFooter from './styles'

interface IProps {
  contact: ILandingContact
  partnerLogos: IPartnerLogo[]
  language: string
}

export class ContactFooter extends PureComponent<IProps> {
  private renderAddressLine = (addressLine: string): ReactNode => <span key={ addressLine }>{ addressLine }</span>

  private renderPartnerLogo = (partnerLogo: IPartnerLogo): ReactNode => (
    <li key={ partnerLogo.image }>
      <img src={ images[partnerLogo.image] } alt={ LiteralsService.get(partnerLogo.altKey, true) } />
    </li>
  )

  public render(): ReactNode {
    const { contact, partnerLogos } = this.props

    return (
      <StyledFooter>
        <section id="contact" className="contact" aria-labelledby="contact-title">
          <h2 id="contact-title">{ LiteralsService.get('contactSectionTitle', true) }</h2>
          <div className="details">
            <h3>{ contact.organisation }</h3>
            <address>
              <p className="address">{ contact.addressLines.map(this.renderAddressLine) }</p>
              <p>
                { LiteralsService.get('phoneAbbreviation', true) }:{ ' ' }
                <a href={ `tel:${ contact.phone.replace(/\s/g, '') }` }>{ contact.phone }</a>
                { ' ' }{ LiteralsService.get('contactFreeCall') }
                <br />
                { LiteralsService.get('contactOpeningHours', true) }
              </p>
              <p>
                { LiteralsService.get('email', true) }:{ ' ' }
                <a href={ `mailto:${ contact.email }` }>{ contact.email }</a>
              </p>
            </address>
          </div>
        </section>
        <section className="partners">
          <ul>{ partnerLogos.map(this.renderPartnerLogo) }</ul>
        </section>
      </StyledFooter>
    )
  }
}
